<style>
.text-danger {
color: #ff4444 ;
}
.card-header-formatting {
    padding-top: 16px;
    padding-bottom: 16px;
    background: linear-gradient(112.2deg, var(--sl-color-primary-400) 14.86%, var(--sl-color-primary-700) 102.08%);
    color: white;
  }
  .card-header-formatting a:visited{
    color: #f7be6a;
  }
</style>

<div [formGroup]="candidateinvite">
  <fadv-grid>
    <fadv-box mb="large">
    <fadv-grid-row>
      <fadv-grid-col style="padding-bottom: 8px" alignment="center">
          <fadv-typography type="heading-small" variant="primary">Legal Name</fadv-typography>
      </fadv-grid-col>
    </fadv-grid-row>
    <fadv-grid-row>
      <fadv-grid-col style="padding-bottom: 8px">
        <fadv-typography type="paragraph-small" variant="neutral">
          Please provide your applicant's legal name at it appears on their government issued identification to ensure accuracy when searching and verifying record data.
        </fadv-typography>
      </fadv-grid-col>
    </fadv-grid-row>
    <fadv-grid-row>
      <fadv-grid-col alignment="{{firstNameAlignment}}" [col]="{ xxl: 6, xl: 6, lg: 6, md: 12, sm: 12, xs: 12 }">
        <!-- <fadv-tooltip placement="right-end" style="position: relative" hoisted="true" distance="100" hoist="true"
        content="Please provide your candidate's legal name at it appears on their government issued identification to ensure accuracy when searching and verifying record data."> -->
        <fadv-input 
        [invalid]="this?.firstNameInvalid"
        (blur)="this?.showValidation('firstName')"
         autofocus="autofocus" 
         formControlName="firstName"
         type="text" 
         label="Applicant First Name *"></fadv-input>
        <!-- </fadv-tooltip> -->
        <span *ngIf="this?.firstNameInvalid == true">
        <small *ngIf="candidateinvite.get('firstName').hasError('required')" class="text-danger">First Name is Required</small>
        <small *ngIf="candidateinvite.get('firstName').hasError('pattern')" class="text-danger">First Name can only contain letters</small>
        <small *ngIf="candidateinvite.get('firstName').hasError('whitespace') && !candidateinvite.get('firstName').hasError('required')" class="text-danger">First Name cannot be empty</small>
        </span>
      </fadv-grid-col>
      <fadv-grid-col alignment="{{lastNameAlignment}}" [col]="{ xxl: 6, xl: 6, lg: 6, md: 12, sm: 12, xs: 12 }">
        <!-- <fadv-tooltip placement="right-end" hoist="true" 
        content="Please provide your candidate's legal name at it appears on their government issued identification to ensure accuracy when searching and verifying record data."> -->
        <fadv-input 
        [invalid]="this?.lastNameInvalid"
        (blur)="this?.showValidation('lastName')" 
        formControlName="lastName" type="text" 
        label="Applicant Last Name *"></fadv-input>
        <!-- </fadv-tooltip> -->
        <span *ngIf="this?.lastNameInvalid == true">
        <small *ngIf="candidateinvite.get('lastName').hasError('required')" class="text-danger">Last Name is Required</small>
        <small *ngIf="candidateinvite.get('lastName').hasError('pattern')" class="text-danger">Last Name can only contain letters</small>
        <small *ngIf="candidateinvite.get('lastName').hasError('whitespace') && !candidateinvite.get('lastName').hasError('required')" class="text-danger">Last Name cannot be empty</small>
        </span>
      </fadv-grid-col>
    </fadv-grid-row>
  </fadv-box>
  <fadv-box mb="large">
  <fadv-grid-row>
    <fadv-grid-col style="padding-bottom: 8px" alignment="center">
        <fadv-typography type="heading-small" variant="primary">Email Address</fadv-typography>
    </fadv-grid-col>
  </fadv-grid-row>
  <fadv-grid-row>
    <fadv-grid-col style="padding-bottom: 8px">
      <fadv-typography type="paragraph-small" variant="neutral">
        Please provide your applicant's valid email address to allow them to submit the required order information.
      </fadv-typography>
    </fadv-grid-col>
  </fadv-grid-row>
  <fadv-grid-row>
    <fadv-grid-col alignment="{{emailAlignment}}" [col]="{ xxl: 6, xl: 6, lg: 6, md: 12, sm: 12, xs: 12 }">
      <fadv-input 
      [invalid]="this?.emailInvalid"
      (blur)="this?.showValidation('email')"
       formControlName="email" 
       type="email" label="Applicant Email *"></fadv-input>
      <span *ngIf="this?.emailInvalid == true">
      <small *ngIf="candidateinvite.get('email').hasError('required')" class="text-danger">Email is Required</small>
      <small *ngIf="candidateinvite.get('email').hasError('email')" class="text-danger">Email must be a valid email address</small>
      </span>
    </fadv-grid-col>
    <fadv-grid-col alignment="{{confirmEmailAlignment}}" [col]="{ xxl: 6, xl: 6, lg: 6, md: 12, sm: 12, xs: 12 }">
      <fadv-input 
      [invalid]="this?.confirmEmailInvalid"
      (blur)="this?.showValidation('confirmEmail')" 
      formControlName="confirmEmail" 
      type="email" 
      label="Confirm Applicant Email *"></fadv-input>
      <small *ngIf="this?.confirmEmailInvalid == true" class="text-danger">Email must match</small>
    </fadv-grid-col>
  </fadv-grid-row>
</fadv-box>
</fadv-grid>
</div>
